import { normalize } from 'normalizr'
import { Commit } from 'vuex'

import Message from '@/models/message'

import axios from '@/axios-module'
import { messageSchema, messagesSchema } from '@/schemas/message'

export enum MessagesActionTypes {
  LoadByBookingId = '[Messages] LoadByBookingId',
  UpdateByBookingId = '[Messages] UpdateByBookingId',
  Send = '[Messages] Send',
}

export enum MessagesMutationTypes {
  LoadStarted = '[Messages] LoadStarted',
  LoadByBookingIdSuccess = '[Messages] LoadByBookingIdSuccess',
  UpdateByBookingIdSuccess = '[Messages] UpdateByBookingIdSuccess',
  SendSuccess = '[Messages] SendSuccess',
}

export enum MessagesGetters {
  Messages = '[Messages] Messages',
}

export interface State {
  messagesLoaded: boolean
  messageIds: number[]
  messageEntities: {
    [id: number]: Message
  }
}

function initialState(): State {
  return {
    messagesLoaded: false,
    messageIds: [],
    messageEntities: {},
  }
}

export default {
  state: initialState,
  getters: {
    [MessagesGetters.Messages](state: State) {
      return state.messageIds.sort().map((id) => state.messageEntities[id])
    },
  },
  actions: {
    async [MessagesActionTypes.LoadByBookingId](
      { commit }: { commit: Commit },
      bookingId: number,
    ) {
      commit(MessagesMutationTypes.LoadStarted)
      const response = await axios.get(
        `/customer/bookings/${bookingId}/messages`,
      )
      commit(
        MessagesMutationTypes.LoadByBookingIdSuccess,
        normalize(response.data, messagesSchema),
      )
    },
    async [MessagesActionTypes.UpdateByBookingId](
      { commit }: { commit: Commit },
      bookingId: number,
    ) {
      const response = await axios.get(
        `/customer/bookings/${bookingId}/messages`,
      )
      commit(
        MessagesMutationTypes.UpdateByBookingIdSuccess,
        normalize(response.data, messagesSchema),
      )
    },
    async [MessagesActionTypes.Send](
      { commit }: { commit: Commit },
      {
        customer,
        bookingId,
        newMessage,
      }: { customer: string; bookingId: number; newMessage: string },
    ) {
      const params = {
        message: { user: customer, body: newMessage, enquiryId: bookingId },
      }
      const response = await axios.post(
        `/customer/bookings/${bookingId}/messages`,
        params,
      )
      commit(
        MessagesMutationTypes.SendSuccess,
        normalize(response.data, messageSchema),
      )
    },
  },
  mutations: {
    [MessagesMutationTypes.LoadStarted](state: State) {
      state.messagesLoaded = false
    },
    [MessagesMutationTypes.LoadByBookingIdSuccess](
      state: State,
      normalizedMessages: any,
    ) {
      state.messageEntities = normalizedMessages.entities.messages
      state.messageIds = normalizedMessages.result
      state.messagesLoaded = true
    },
    [MessagesMutationTypes.UpdateByBookingIdSuccess](
      state: State,
      normalizedMessages: any,
    ) {
      updateMessages(state, normalizedMessages)
    },
    [MessagesMutationTypes.SendSuccess](state: State, normalizedMessage: any) {
      updateMessage(
        state,
        normalizedMessage.entities.messages[normalizedMessage.result],
      )
    },
  },
}

function updateMessages(state: State, normalizedData: any) {
  const messages = normalizedData.entities.messages

  normalizedData.result.map((messageId: number) => {
    const message = messages[messageId]
    updateMessage(state, message)
  })
}

function updateMessage(state: State, message: any) {
  state.messageEntities = { ...state.messageEntities, [message.id]: message }

  if (state.messageIds.indexOf(message.id) < 0) {
    state.messageIds = [...state.messageIds, message.id]
  }
}
